import { Skeleton } from "@/components/ui/skeleton";

export function OrgMembersSectionSkeleton({ rows = 4 }: { rows?: number }) {
  return (
    <div className="mt-3 divide-y">
      {Array.from({ length: rows }).map((_, index) => (
        <div key={index} className="flex min-h-14 flex-wrap items-center gap-3 py-3">
          <div className="min-w-48 flex-1">
            <Skeleton className="h-4 w-48 max-w-full" />
            <Skeleton className="mt-2 h-3 w-20" />
          </div>
          <Skeleton className="h-9 w-32" />
          <Skeleton className="size-8" />
        </div>
      ))}
    </div>
  );
}
